import axios from 'axios';

const instance = axios.create({
  baseURL: '/api',
});

const getUserList = () => instance.get('/users');

const getDeviceList = (user, page = 1, pageSize = 20, begin, end) => instance.get(`/${user}`, {
  params: {
    page, pageSize, begin, end,
  },
});
const getDeviceDetail = (user, deviceId) => instance.get(`/${user}/${deviceId}`);
const getHistoryData = (user, deviceId, measurement, timeSpan) => instance.get(`/${user}/${deviceId}/${measurement}/${timeSpan}`);

export {
  getUserList,
  getDeviceList,
  getDeviceDetail,
  getHistoryData,
};
